






















import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { find } from 'lodash';

import LoadingSpinner from '@reciprocity/loading-spinner';
import { ZenLink } from 'zenComponents';
import { PATHS } from '../../../router/paths';
import { PageExtensionSchema } from '@/types/apiTypes';
import { sendRequest, getRequest } from '../../../utils/client/client';

export default Vue.extend({
  name: 'IntegrationSettingsPage',
  components: {
    LoadingSpinner,
    ZenLink,
  },
  data() {
    return {
      loading: <boolean>true,
      jwt: <string | null>null,
      PATHS,
    };
  },
  computed: {
    ...mapGetters(['pageExtensions', 'route', 'routes', 'csrfToken', 'featureFlags', 'featureFlagState']),
    integrationName(): string {
      return this.route.params.integrationName;
    },
    currentExtension(): PageExtensionSchema {
      return find(this.pageExtensions, { key: this.integrationName });
    },
    iframeUrl(): string {
      if (this.jwt) {
        return `${this.currentExtension.iframeUrl}?jwt=${this.jwt}`;
      }
      return '';
    },
  },
  watch: {
    currentExtension() {
      this.reloadComponent();
    },
  },
  created() {
    this.reloadComponent();
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  destroyed() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
    }),
    sendMessage(type: string, payload: any) {
      const iframeElement = this.$refs.iframe as HTMLIFrameElement;
      iframeElement.contentWindow!.postMessage({ type, payload }, iframeElement.src);
    },
    handleMessage(messageEvent: MessageEvent) {
      if (this.iframeUrl.startsWith(messageEvent.origin)) {
        this.receiveMessage(messageEvent);
      }
    },
    /* eslint-disable-next-line complexity */
    async receiveMessage(messageEvent: MessageEvent) {
      switch (messageEvent.data.type) {
        case 'resize':
          break;
        case 'request': {
          const { routeName, method = 'get', data = null } = messageEvent.data.payload;
          try {
            const responseData = await sendRequest({
              method,
              url: this.routes[routeName],
              data,
              headers: { 'X-CSRF-Token': this.csrfToken },
            });
            this.sendMessage('response', responseData);
          } catch (error) {
            this.sendMessage('error', error.response.data);
          }
          break;
        }
        case 'loaded':
          this.loading = false;
          // TODO: ZEN-11471 - Remove after ZEN-10779 is delivered
          this.sendMessage('flags', this.featureFlags);
          break;
        case 'alert':
          this.showAlert(messageEvent.data.payload);
          break;
        default:
          break;
      }
    },
    async generateJwt() {
      const url: string = this.routes.generateJwt.replace('__PLUGIN_KEY__', this.currentExtension.key);
      const responseData = await getRequest({ url });
      return responseData;
    },
    async reloadComponent() {
      this.jwt = null;

      this.setPageTitle({
        title: this.currentExtension.integrationName,
        visible: false,
      });

      this.jwt = await this.generateJwt();
    },
  },
});
